import { styled, Box } from '@mui/material';

export const ContactWrapper = styled(Box)(
	({ theme }) => `
background: #EFEEF4;  
min-height: 100vh;  
padding-top:${theme.header.height}; 
`
);
